import axios from 'axios';

const loadExternalConfig = () => axios.get('./static/config.json');

export default loadExternalConfig;



// WEBPACK FOOTER //
// ./src/api/config.js